import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { UserGuide } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuidesService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getMyUserGuides(): Observable<UserGuide[]> {
    return this.http
      .get<UserGuide[]>(`${environment.apiEndpoint}/Help/UserGuides`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  setGuideAsRead(guideId: Number): Observable<UserGuide> {
    return this.http
      .get<UserGuide>(`${environment.apiEndpoint}/Help/Guides/SetRead/${guideId}`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
